const ANTRIEBE_ARRAY = ['090', '110', '150', '200', '280', '350'];
const HEBELARM_ARRAY = [90, 110, 150, 200, 280, 350];
const WIRKUNGSGRADZYLINDER = 0.8;
const WIRKUNGSGRADFEDER = 0.75;

const VERSTELLBEREICH_ARRAY = [35, 43, 58, 77, 118, 135];

const HUB_ARRAY_SYM = [180, 220, 300, 400, 560, 700]; // 0 knickwinkel 0° - AS-S und AS
const HUB_ARRAY_CANTED = [185, 226, 310, 412, 576, 721]; // 12 knickwinkel 12° - AS-C und AS

const KOLBENSTANGE_DURCHMESSER_ARRAY = [30, 40, 50, 63, 63, 80];

const ANTRIEBE_MAX_NETTO_DREHMOMENT_ASC = [11000, 30000, 60000, 100000, 200000, 350000];
const ANTRIEBE_MAX_NETTO_DREHMOMENT_ASS = [11000, 30000, 60000, 100000, 200000, 350000];

/**
 * Zylinderdurchmesser für AS-P
 */

const zylDurchmesser90: number[] = [200, 250, 300, 350, 400, 450, 500, 550];
const zylDurchmesser110: number[] = [300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800];
const zylDurchmesser150: number[] = [350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900];
const zylDurchmesser200: number[] = [450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000];
const zylDurchmesser280: number[] = [500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1050, 1100, 1150, 1200];
const zylDurchmesser350: number[] = [650, 700, 750, 800, 850, 900, 950, 1000, 1050, 1100, 1150, 1200, 1250, 1300, 1350, 1400, 1450];

const zylDurchmesser90Hydraulic: number[] = [30, 40, 50, 60, 70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300];
const zylDurchmesser110Hydraulic: number[] = [50, 60, 70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350];
const zylDurchmesser150Hydraulic: number[] = [70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450];
const zylDurchmesser200Hydraulic: number[] = [100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450];
const zylDurchmesser280Hydraulic: number[] = [140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450, 500, 550, 600];
const zylDurchmesser350Hydraulic: number[] = [160, 180, 200, 220, 250, 280, 300, 350, 400, 450, 500, 550, 600, 650];

const zylDurchmesser90Gas: number[] = [30, 40, 50, 60, 70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300];
const zylDurchmesser110Gas: number[] = [50, 60, 70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350];
const zylDurchmesser150Gas: number[] = [70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450];
const zylDurchmesser200Gas: number[] = [100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450];
const zylDurchmesser280Gas: number[] = [140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450, 500, 550, 600];
const zylDurchmesser350Gas: number[] = [160, 180, 200, 220, 250, 280, 300, 350, 400, 450, 500, 550, 600, 650];

const zylDurchmesser90EH: number[] = [30, 40, 50, 60, 70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300];
const zylDurchmesser110EH: number[] = [50, 60, 70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350];
const zylDurchmesser150EH: number[] = [70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450];
const zylDurchmesser200EH: number[] = [100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450];
const zylDurchmesser280EH: number[] = [140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450, 500, 550, 600];
const zylDurchmesser350EH: number[] = [160, 180, 200, 220, 250, 280, 300, 350, 400, 450, 500, 550, 600, 650];

const zylDurchmesser90GO: number[] = [30, 40, 50, 60, 70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300];
const zylDurchmesser110GO: number[] = [50, 60, 70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350];
const zylDurchmesser150GO: number[] = [70, 80, 90, 100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450];
const zylDurchmesser200GO: number[] = [100, 125, 140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450];
const zylDurchmesser280GO: number[] = [140, 160, 180, 200, 220, 250, 280, 300, 350, 400, 450, 500, 550, 600];
const zylDurchmesser350GO: number[] = [160, 180, 200, 220, 250, 280, 300, 350, 400, 450, 500, 550, 600, 650];

const ZYLDURCHMESSER: any = {
    P: [zylDurchmesser90, zylDurchmesser110, zylDurchmesser150, zylDurchmesser200, zylDurchmesser280, zylDurchmesser350],
    H: [zylDurchmesser90Hydraulic, zylDurchmesser110Hydraulic, zylDurchmesser150Hydraulic, zylDurchmesser200Hydraulic, zylDurchmesser280Hydraulic, zylDurchmesser350Hydraulic],
    G: [zylDurchmesser90Gas, zylDurchmesser110Gas, zylDurchmesser150Gas, zylDurchmesser200Gas, zylDurchmesser280Gas, zylDurchmesser350Gas],
    EH: [zylDurchmesser90EH, zylDurchmesser110EH, zylDurchmesser150EH, zylDurchmesser200EH, zylDurchmesser280EH, zylDurchmesser350EH],
    GO: [zylDurchmesser90GO, zylDurchmesser110GO, zylDurchmesser150GO, zylDurchmesser200GO, zylDurchmesser280GO, zylDurchmesser350GO]
};

// TODO: Reihenfolge (verkehrt) in ordnung?
const federPakete90 = ['D1', 'E1', 'A2', 'B2', 'C2', 'D2', 'E2', 'F2', 'D3'].reverse();
const federPakete110 = ['E1', 'E1', 'F1', 'A2', 'B2', 'C2', 'D2', 'F2'].reverse();
const federPakete150 = ['F1', 'G1', 'H1', 'D2', 'E2', 'F2', 'G2'].reverse(); // A3 raus for now
const federPakete200 = ['D1', 'C2', 'E2', 'F2', 'A3'].reverse();
const federPakete280 = ['D1', 'E1', 'F1', 'D2', 'E2', 'F2'].reverse(); // A2 und A3 B2 B3 raus
const federPakete350 = ['A1', 'C2'].reverse();

const federPaketeArray = [federPakete90, federPakete110, federPakete150, federPakete200, federPakete280, federPakete350];

const federRate90 = { A2: [102.68, 0], B2: [102.68, 0], C2: [102.68, 0], D1: [75.33, 37.66], D2: [75.33, 0], D3: [0, 37.66], E1: [75.33, 37.66], E2: [75.33, 0], F2: [75.33, 0] };
const federRate110 = { A2: [158.15, 0], B2: [158.15, 0], C2: [158.15, 0], D1: [102.68, 51.34], D2: [102.68, 0], E1: [102.68, 51.34], F1: [102.68, 51.34], F2: [102.68, 0] };
const federRate150 = { D2: [285.64, 0], E2: [285.64, 0], F1: [158.15, 79.08], F2: [158.15, 0], G1: [158.15, 79.08], G2: [158.15, 0], H1: [0, 79.08] };
const federRate200 = { A3: [105.43, 0], C2: [105.43, 52.72], D1: [105.43, 52.72], E2: [285.64, 0], F2: [285.64, 0] };
const federRate280 = { D1: [190.43, 107.72], D2: [190.43, 0], E1: [190.43, 107.72], E2: [190.43, 0], F1: [190.43, 107.72], F2: [190.43, 0] };
const federRate350 = { A1: [142.82, 80.79], C2: [190.43, 0] };

const FEDERRATEARRAY = [federRate90, federRate110, federRate150, federRate200, federRate280, federRate350];

const vorspannung90 = { A2: 360, B2: 313, C2: 266, D1: 218, D2: 218, D3: 218, E1: 168, E2: 168, F2: 128 };
const vorspannung110 = { A2: 507, B2: 441, C2: 375, D1: 218, D2: 218, E1: 266, F1: 313, F2: 313 };
const vorspannung150 = { D2: 475, E2: 390, F1: 375, F2: 375, G1: 300, G2: 300, H1: 410 };
const vorspannung200 = { A3: 660, C2: 660, D1: 580, E2: 525, F2: 450 };
const vorspannung280 = { D1: 985, D2: 985, E1: 850, E2: 850, F1: 700, F2: 700 };
const vorspannung350 = { A1: 1300, C2: 700 };

const VORSPANNUNGARRAY = [vorspannung90, vorspannung110, vorspannung150, vorspannung200, vorspannung280, vorspannung350];

const federPaketAnzahl90 = { A2: 1, B2: 1, C2: 1, D1: 1, D2: 1, D3: 1, E1: 1, E2: 1, F2: 1 };
const federPaketAnzahl110 = { A2: 1, B2: 1, C2: 1, D1: 1, D2: 1, E1: 1, F1: 1, F2: 1 };
const federPaketAnzahl150 = { D2: 1, E2: 1, F1: 1, F2: 1, G1: 1, G2: 1, H1: 1 };
const federPaketAnzahl200 = { A3: 1, C2: 1, D1: 1, E2: 1, F2: 1 };
const federPaketAnzahl280 = { D1: 1, E1: 1, F1: 1, D2: 1, E2: 1, F2: 1 };
const federPaketAnzahl350 = { A1: 1, C2: 1 };

const FEDERPAKETEANZAHLARRAY = [federPaketAnzahl90, federPaketAnzahl110, federPaketAnzahl150, federPaketAnzahl200, federPaketAnzahl280, federPaketAnzahl350];

const getHebelarm = (antriebsIndex: number) => {
    return HEBELARM_ARRAY[antriebsIndex];
};

const getWirkungsgradZylinder = () => {
    return WIRKUNGSGRADZYLINDER;
};

const asBasis = {
    getHebelarm,
    getWirkungsgradZylinder,
    ANTRIEBE_MAX_NETTO_DREHMOMENT_ASC, // maxDrehmomentAntriebeASC
    ANTRIEBE_MAX_NETTO_DREHMOMENT_ASS, // maxDrehmomentAntriebeASS
    federPaketeArray,
    ZYLDURCHMESSER,
    FEDERRATEARRAY,
    VORSPANNUNGARRAY,
    FEDERPAKETEANZAHLARRAY,
    WIRKUNGSGRADFEDER,
    VERSTELLBEREICH_ARRAY,
    HUB_ARRAY_SYM,
    HUB_ARRAY_CANTED,
    KOLBENSTANGE_DURCHMESSER_ARRAY,
    ANTRIEBE_ARRAY
};

export default asBasis;
